import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useEffect, useMemo } from 'react'
import { Portal } from 'react-portal'

import classNames from '../../utils/classNames'
import closeModal from '../../utils/closeModal'

interface ToastMessageProps {
  text: string
  isValid?: boolean
}

const ToastMessage = ({ text, isValid }: ToastMessageProps) => {
  const modal = useModal()

  useEffect(() => {
    if (modal.visible) {
      setTimeout(() => closeModal(modal), 5000)
    }
  }, [modal.visible])

  const classes = useMemo(() => {
    if (isValid) return 'bg-[#ebf8ea] border-[#41BC2C] [&>div]:bg-[#41BC2C]'
    if (isValid === false)
      return 'bg-[#ffeced] border-[#FF4040] [&>div]:bg-[#FF4040]'
    return 'bg-[#e7e7ee] border-[#888]'
  }, [isValid])

  return (
    <Portal>
      <div
        className={classNames(
          'grid items-center grid-cols-[40px_1fr] w-full max-w-[350px] fixed -translate-x-2/4 border z-[500] overflow-hidden animate-[fadeIn_0.2s] transition-all duration-[0.2s] rounded-md border-solid left-2/4 ',
          modal.visible ? 'opacity-100 top-2.5 xl:top-5 ' : 'opacity-0 top-0',
          classes,
        )}>
        <div className="w-10 h-full bg-[#888] flex p-2.5">
          {isValid && (
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.0001 0C4.486 0 0 4.48594 0 9.99994C0 15.5139 4.486 19.9999 10.0001 19.9999C15.5141 19.9999 20 15.5139 20 9.99994C20 4.48594 15.5141 0 10.0001 0ZM10.0001 18.3605C5.38993 18.3605 1.63933 14.6101 1.63933 9.99994C1.63933 5.38987 5.38993 1.63933 10.0001 1.63933C14.6101 1.63933 18.3607 5.38987 18.3607 9.99994C18.3607 14.6101 14.6101 18.3605 10.0001 18.3605Z"
                fill="white"
              />
              <path
                d="M14.3257 6.16191L8.38827 12.0994L5.67367 9.38478C5.35354 9.06472 4.83459 9.06472 4.51446 9.38478C4.1944 9.70491 4.1944 10.2239 4.51446 10.544L7.80867 13.8382C7.96873 13.9982 8.1785 14.0783 8.38827 14.0783C8.59804 14.0783 8.80781 13.9982 8.96788 13.8382L15.4849 7.32119C15.8049 7.00106 15.8049 6.48211 15.4849 6.16198C15.1648 5.84185 14.6457 5.84185 14.3257 6.16191Z"
                fill="white"
              />
            </svg>
          )}
          {isValid === false && (
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_1523_4433)">
                <path
                  d="M10.0001 0C4.486 0 0 4.48594 0 9.99994C0 15.5139 4.486 19.9999 10.0001 19.9999C15.5141 19.9999 20 15.5139 20 9.99994C20 4.48594 15.5141 0 10.0001 0ZM10.0001 18.3605C5.38993 18.3605 1.63933 14.6101 1.63933 9.99994C1.63933 5.38987 5.38993 1.63933 10.0001 1.63933C14.6101 1.63933 18.3607 5.38987 18.3607 9.99994C18.3607 14.6101 14.6101 18.3605 10.0001 18.3605Z"
                  fill="white"
                />
                <path
                  d="M6.25 10H13.75"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1523_4433">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}
          {isValid === undefined && (
            <svg
              width={20}
              height={20}
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              fill="none"
              stroke="#fff">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
              />
            </svg>
          )}
        </div>
        <p className="text-sm text-[#444] px-3 py-2 xl:text-base xl:max-w-[500px]">
          {text}
        </p>
      </div>
    </Portal>
  )
}

export default NiceModal.create(ToastMessage)
